(function () {
  function mount(root) {
    var tabsEl = root.querySelector('.ga-faq__tabs');
    var selectEl = root.querySelector('.ga-faq__select');
    var panels = root.querySelectorAll('.ga-faq__panel');
    if (!tabsEl || !selectEl || !panels.length) return;

    function activate(id) {
      var tabs = tabsEl.querySelectorAll('.ga-faq__tab');
      tabs.forEach(function (b) {
        b.setAttribute('aria-selected', b.dataset.id === id ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        if (p.dataset.id === id) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      });
      if (selectEl.value !== id) selectEl.value = id;
    }

    tabsEl.addEventListener('click', function (e) {
      var btn = e.target.closest('.ga-faq__tab');
      if (btn && btn.dataset.id) activate(btn.dataset.id);
    });

    selectEl.addEventListener('change', function (e) {
      activate(e.target.value);
    });
  }

  function init() {
    document.querySelectorAll('[data-faq]').forEach(function (root) {
      if (root.dataset.faqMounted === '1') return;
      root.dataset.faqMounted = '1';
      mount(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
